export default {
  'path': '/demo/modal',
  'meta': {
    'name': 'demo-ModalForm 组件集合',
    'title': 'ModalForm 组件集合',
    'isComponentDoc': true,
    'category': 'Form'
  }
};
